import { getTaggingEnrollment } from '../api/spm';
export default async (logger) => {
    return await getTaggingEnrollment({}, logger);
};
